module.exports = __webpack_public_path__ + "static/media/red-down-arrow.9ea4b62f.png";